export default __webpack_public_path__ + "static/media/swt3.b30b9c86.svg";